import api from '@/api';

const { $student, $pricing, $billing, $payment  } = api;

export const { $studentAccount, $students, $exceptions, $billingData, $discount } = $student;
export const { $types } = $pricing;
export const { $provincias, $localidades, $process } = $billing;
export const { $payments, $transfer } = $payment;
